<template>
    <div
        :class="{ 'fc-pending': _.get(data, 'extendedProps.status.id') === 8 }"
        class="t-body"
    >
        <div class="complaint">
            <i
                v-if="data.extendedProps.repeat > 1"
                v-b-tooltip
                class="famfamfam-silk arrow_refresh"
                title="Recurring appointment"
                style="margin-right: 1% !important;"
            ></i>
            <i
                v-if="_.get(data, 'extendedProps.status')"
                :class="statusClass(_.get(data, 'extendedProps.status.id'))"
                v-b-tooltip
                :title="_.get(data, 'extendedProps.status').value"
                class="famfamfam-silk"
                style="margin-right: 1% !important;"
            ></i>
            <i
                v-if="
                    _.get(
                        data,
                        'extendedProps.appointmentLocation.address_label'
                    ) &&
                    _.get(
                        data,
                        'extendedProps.appointmentLocation.address_label'
                    ) != ''
                "
                @click="showMap(data.extendedProps.appointmentLocation)"
                v-b-tooltip
                :title="data.extendedProps.appointmentLocation.address_label"
                class="famfamfam-silk map"
                style="margin-right: 1% !important;"
            ></i>
            <i
                v-if="_.get(data, 'extendedProps.first_time') > 0"
                v-b-tooltip
                :title="
                    _firstTimeText(
                        data.extendedProps.first_time,
                        data.extendedProps.petCarePatient
                    )
                "
                class="famfamfam-silk star"
                style="margin-right: 1% !important;"
            ></i>
            <span v-if="data.extendedProps.patient">
                <a
                    v-if="
                        _.get(
                            data,
                            'extendedProps.patient.single_business_patient.isactive'
                        )
                    "
                    @click.ctrl.stop.exact
                    @click.stop.exact="
                        goToPatientProfile(
                            data.extendedProps.patient.encoded_id,
                            $event
                        )
                    "
                    :href="`/view/patient/profile/${data.extendedProps.patient.encoded_id}`"
                    >{{ data.extendedProps.patient.name }}</a
                >
                <span v-else>{{ data.extendedProps.patient.name }}</span>
            </span>
            <span v-if="data.extendedProps.client">
                (<a
                    v-if="
                        USE_CLIENT_MODULE_VUE &&
                        _.get(
                            data,
                            'extendedProps.client.single_business_actor.isactive'
                        )
                    "
                    @click.ctrl.stop.exact
                    @click.stop.exact="
                        goToClientProfileView(
                            data.extendedProps.client.encoded_id,
                            $event
                        )
                    "
                    :href="`/view/client/profile/${data.extendedProps.client.encoded_id}`"
                    >{{ data.extendedProps.client.lastname }},
                    {{ data.extendedProps.client.firstname }}</a
                >
                <a
                    v-else-if="
                        !USE_CLIENT_MODULE_VUE &&
                        _.get(
                            data,
                            'extendedProps.client.single_business_actor.isactive'
                        )
                    "
                    @click.stop
                    :href="env.APPS + '..' + data.extendedProps.client.ci_url"
                    >{{ data.extendedProps.client.lastname }},
                    {{ data.extendedProps.client.firstname }}</a
                >
                <span v-else
                    >{{ data.extendedProps.client.lastname }},
                    {{ data.extendedProps.client.firstname }}</span
                >)
            </span>
            <strong>{{ title }}</strong>
            <span
                v-if="
                    _.get(
                        data,
                        'extendedProps.appointmentLocation.address_label'
                    )
                "
                >&nbsp;{{
                    data.extendedProps.appointmentLocation.address_label
                }}.</span
            >
            <span>&nbsp;{{ data.extendedProps.note }}</span>
        </div>
    </div>
</template>
<style>
.t-body {
    height: 100%;
    background: rgba(255, 255, 255, 0.5);
}
div.fc-content {
    height: 100%;
    padding-left: 1px;
    padding-right: 1px;
}
.complaint {
    display: -webkit-box;
    /* -webkit-line-clamp: 4; */
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.fc-pending {
    background-image: linear-gradient(
        45deg,
        rgba(255, 255, 255, 0.25) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.25) 50%,
        rgba(255, 255, 255, 0.25) 75%,
        transparent 75%,
        transparent
    );
    background-size: 1rem 1rem;
}
</style>
<script>
import ScheduleHelper from "@/module/schedule/helper";
export default {
    name: "FcEvent",
    mixins: [ScheduleHelper],
    props: ["data", "router"],
    data() {
        return {
            resources: {},
            options: {
                inline: true,
                format: "DD/MM/YYYY",
                useCurrent: false
            },
            date: new Date(),
            show: true,
            timer: [],
            USE_CLIENT_MODULE_VUE: process.env.USE_CLIENT_MODULE_VUE === "true"
        };
    },
    computed: {
        title() {
            let title = this.data.title ? this.data.title.trim() : "";
            return title.endsWith(".") ? title : title + ".";
        }
    },
    methods: {
        showMap(appointmentLocation) {
            window.open(
                "https://www.google.com/maps/place/" +
                    appointmentLocation.address_label.replace(/#/g, "%23"),
                "_blank"
            );
        },
        goToClientProfileView(encodedId, event) {
            event.preventDefault();
            this.router.push({
                name: "client_profile",
                params: {
                    id: encodedId
                }
            });
        },
        goToPatientProfile(encodedId, event) {
            if (process.env.USE_PATIENT_MODULE_VUE === "true") {
                event.preventDefault();
                this.router.push({
                    name: "patient_profile",
                    params: {
                        id: encodedId
                    }
                });
            }
        }
    }
};
</script>
